import { MetricsPortModel } from "./MetricsPortModel";
import { BaseModelOptions, GenerateModelEvent } from '@projectstorm/react-canvas-core';
import { AbstractReactFactory, GenerateWidgetEvent, AbstractModelFactory } from '@projectstorm/react-canvas-core';
import { DiagramEngine } from '@projectstorm/react-diagrams'

export class MetricsPortFactory extends AbstractModelFactory<MetricsPortModel, DiagramEngine>{
    constructor() {
        super('metrics-port');
    }
    generateModel(event: GenerateModelEvent) {
        return new MetricsPortModel({
            name: 'port',
            in: false,
            connectableTypes: []
        })
    }
}